import { useEffect, useState } from 'react';
import axios from 'axios';

export interface Employee {
  ['@odata.etag']: string;
  new_name: string;
  new_employeeid: string;
  cra0e_email: string;
}

export const useGetAllUsers = () => {
  const [users, setUsers] = useState<Array<Employee>>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const getHolidays = async () => {
    setLoadingUsers(true);
    try {
      const response = await axios.get('api/employees/active');
      const employees = response.data;
      sessionStorage.setItem(
        'employees',
        JSON.stringify({
          employees,
          date: new Date(2023, 8, new Date().getDate()),
        })
      );
      setUsers(employees);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingUsers(false);
    }
  };

  useEffect(() => {
    const employees = sessionStorage.getItem('employees');
    const currentDay = new Date(2023, 8, new Date().getDate());
    if (!employees || new Date(JSON.parse(employees).date) < currentDay) {
      getHolidays();
    }
    if (employees) {
      setUsers(JSON.parse(employees).employees);
    }
  }, []);

  return { users, loadingUsers };
};
